import React from 'react';

import WorkingBossShow from 'components/Tvendo/Distribution/Operations/WorkingBoss/Detail/Show';

export default function WorkingBossDetail() {
  return <WorkingBossShow />;
}
